import { isTemporaryPackChatError } from "./thread-error-copy";

export const PACK_CHAT_STALE_TIME = 30_000;
export const PACK_CHAT_CHECK_INTERVAL = 15_000;

export const packChatCheckInterval = (query: { state: { error: unknown } }) =>
  query.state.error && !isTemporaryPackChatError(query.state.error)
    ? false
    : PACK_CHAT_CHECK_INTERVAL;

export const packChatQueryOptions = {
  staleTime: PACK_CHAT_STALE_TIME,
  // ETags belong to exact response objects; preserve their cache identity.
  structuralSharing: false,
  refetchInterval: packChatCheckInterval,
  refetchIntervalInBackground: false,
  retry: false,
} as const;
